module.exports = __webpack_public_path__ + "img/fail.a671f117.png";